<div class="mx-auto max-w-(--breakpoint-2xl)">
  <div class="w-full">
    <div class="my-10 text-center">
      <h2 class="text-2xl font-medium text-gray-800 dark:text-white/90">
        @if (product.id) {
          Edit Product
        } @else {
          Add Product
        }
      </h2>
    </div>
  </div>

  <form [formGroup]="form">

    <div class="grid grid-cols-2 gap-3 items-start">

      <div class="rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">

        <div class="px-5 py-4 sm:px-6 sm:py-5">
          <h3 class="text-base font-medium text-gray-800 dark:text-white/90">
            Product Information
          </h3>
        </div>

        <div class="p-5 space-y-6 border-t border-gray-100 dark:border-gray-800 sm:p-6">
          <div class="-mx-2.5 flex flex-wrap gap-y-5">
            <div class="w-full px-2.5 xl:w-1/2">
              <app-text-input [control]="form.controls.name" [name]="'name'" [placeholder]="'Product Name'" [label]="'Name'"></app-text-input>
            </div>

            <div class="w-full px-2.5 xl:w-1/2">
              <app-text-input [control]="form.controls.price" [mask]="'separator.2'" [thousandSeparator]="','" [name]="'price'" [placeholder]="'0.00'" [label]="'&pound; Price'"></app-text-input>
            </div>

            <div class="w-full px-2.5">
              @if (editor) {
                <div class="NgxEditor__Wrapper min-h-40 h-auto">
                  <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
                  <ngx-editor
                    [formControl]="form.controls.description"
                    [editor]="editor"
                    [placeholder]="'Type here...'"
                  ></ngx-editor>
                </div>
              }
            </div>

            <div class="w-1/2 px-2.5">
              <app-select [control]="form.controls.status" [choices]="statusChoices" label="Status"></app-select>
            </div>

            <div class="w-1/2 px-2.5">
              <app-select [control]="form.controls.category" [choices]="categoryChoices" label="Category"></app-select>
            </div>

            <div class="w-1/2 px-2.5">
              <app-select [control]="form.controls.destined_for" [choices]="destinedForChoices" label="Destined For"></app-select>
            </div>

            <div class="w-1/2 px-2.5">
              <app-checkbox [control]="form.controls.is_minimum_spend" label="Include in minimum spend"></app-checkbox>
            </div>

            <!--          <div class="w-full px-2.5">-->
            <!--            <app-checkbox [control]="form.controls.in_stock" label="In Stock"></app-checkbox>-->
            <!--          </div>-->
          </div>
        </div>
      </div>


      <div class="rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
        <div class="px-5 py-4 sm:px-6 sm:py-5">
          <h3 class="text-base font-medium text-gray-800 dark:text-white/90">
            Product Image
          </h3>
        </div>

        <div class="p-5 space-y-6 border-t border-gray-100 dark:border-gray-800 sm:p-6">
          <div class="-mx-2.5 flex flex-wrap gap-y-5">

            <div class="h-full w-full px-2.5 flex flex-col items-start justify-between">
              @if (imageUrl) {
                <img [src]="imageUrl" alt="Selected Image" class="mt-2 max-w-[368px] max-h-[232px]">
              } @else {
                @if (product.images.length > 0 && product.images[0].sm) {
                  <img [src]="product.images[0].sm" alt="Product Image" class="h-full mt-2">
                }
              }
              <div class="w-full mt-5">
                <input type="file" (change)="onFileChange($event)"
                       class="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full
                       file:border-0 file:text-sm file:font-semibold file:bg-brand-50 file:text-brand-700 hover:file:bg-brand-100">
              </div>
            </div>

          </div>

        </div>
      </div>

      @if (product.id) {
        <div class="col-span-2">
          <app-data-table [paginate]="false" [title]="'Product Variants'" [dataPage]="variantsPage" [columns]="variantsColumns" [rowActions]="variantsRowActions" [hover]="false">
            <div header class="w-full flex flex-row items-center justify-end gap-3">
              <app-text-input [control]="variantNameControl" [name]="'variantName'" [placeholder]="'Variant Name'"></app-text-input>
              <button (click)="addVariant()"
                      class="h-12 text-theme-sm shadow-theme-xs inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2.5 font-medium
                             text-gray-700 hover:bg-gray-50 hover:text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200">
                <lucide-icon [name]="PlusIcon"></lucide-icon>
                Add Variant
              </button>
            </div>
          </app-data-table>
        </div>

        <!-- Delete Confirmation Modal -->
        @if (variantToDelete) {
          <app-modal
            [title]="'Delete Variant'"
            [content]="'Are you sure you want to delete variant - ' + variantToDelete.name + '?'"
            [show]="!!variantToDelete"
            [closeButtonLabel]="'Cancel'"
            [confirmButtonLabel]="'Yes, Proceed'"
            (onClose)="variantToDelete = undefined"
            (onConfirm)="confirmDelete()"
          ></app-modal>
        }
      }

    </div>


    <div class="w-full mt-3 flex justify-end gap-3">
      <app-button [label]="'Cancel'" [disabled]="processing" [style]="'secondary'" (click)="cancel()"></app-button>
      <app-button [label]="'Save'" [disabled]="processing || !form.valid || form.pristine" [icon]="SaveIcon" (click)="save()"></app-button>
    </div>

    <!--  @if (validationErrors.length > 0) {-->
    <!--    <div class="mt-4 p-4 border border-red-500 bg-red-100 text-red-700 rounded-lg">-->
    <!--      <h3 class="font-medium">Validation Errors:</h3>-->
    <!--      <ul class="list-disc list-inside">-->
    <!--        @for (error of validationErrors; track error) {-->
    <!--          <li>{{ error }}</li>-->
    <!--        }-->
    <!--      </ul>-->
    <!--    </div>-->
    <!--  }-->

  </form>
</div>
